export const environment = {
  production: true,
  restURL: {
    // baseUrl: 'https://apidev-kop.jangka.id/v001/',
    // authUrl: 'https://apidev-kop.jangka.id/v001/',

    // baseUrl: 'https://apistag-kop.jangka.id/v001/',
    // authUrl: 'https://apistag-kop.jangka.id/v001/',

    // PROD
    // baseUrl: 'https://api-operator.kospinus.com/v001/',
    // authUrl: 'https://api-operator.kospinus.com/v001/',

    baseUrl: 'https://api-operator.kospinus.com/v001/',
    authUrl: 'https://api-operator.kospinus.com/v001/',
    baseUrlCbi: 'https://cbi.kospinus.com/',

    xApiKey: 'kn39fA7vP2sLk5zXuMtzrWjjufhakjj999985g19iT',

    provision_key: 'QA2euZP3O214ZdYbXpmS0IOKfIPEZPy7',
    client_id: '0jubsFJCBOqq0aGpW30NEXB45s0jzes3',
    client_secret: '6btZKFb2u5tHIs1vheQbXqPlBRvJRDu8',
    grant_type: 'password',
  },
};
